var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"smart-points"},[(_vm.shouldDisplayDefault)?_c('SmartPointDefault',{attrs:{"transporter":_vm.transporter}}):_vm._e(),_vm._v(" "),(_vm.shouldDisplayWidget)?_c('SmartPointWidget',{attrs:{"transporter":_vm.transporter}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }